export default __webpack_public_path__ + "static/media/35_Meow.d4955f3c.JPG";